/**
 * Shared posthog-js init options for all browser surfaces.
 * Session replay is on when the project key is set and PostHog project
 * "Record user sessions" is enabled (session_recording_opt_in).
 * Inputs/text are masked; console log capture is off (PII risk).
 */
export const POSTHOG_BROWSER_INIT_DEFAULTS = {
  person_profiles: 'identified_only' as const,
  capture_pageview: true,
  capture_pageleave: true,
  disable_session_recording: false,
  enable_recording_console_log: false,
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '*',
  },
};
